/**
*
* Footer
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import mediainjector from '../../style/mediainjector';


export const FooterWrap = styled.footer`
position: relative;
width: 100%;
padding: 20px 20px 10px;
background-color: ${(props) => props.bgcolor};
p {
  color: ${(props) => props.color};
  font-size: 1.5rem;
  text-align: center;
  padding-bottom: 20px;
  margin: 0 auto;
  a {
    display: inline;
    color: inherit;
    text-decoration: underline;
  }
  ${mediainjector.lt480`
    font-size: 12px;
  `}
  }
  ${mediainjector.print`
    display: none;
  `}
`;

const LinkList = styled.section`
  color: #fff;
  text-align: center;
  ul {
    list-style: none;
    padding-bottom: ${({ paddingBottom }) => paddingBottom || '2em'};
    padding-left: 0;
    max-width: 960px;
    margin: auto;
    a {
      color: inherit;
      text-decoration: none;
      padding: 0.3em 1em;
      border-radius: 6px;
    }
    li {
      padding: 0.56em 0;
      margin-bottom: .6em;
      ${mediainjector.lt667`
        border-bottom: 1px solid rgba(255,255,255,0.3);
        &:last-child {
          border-bottom: none;
        }
      `}
    }
    ${mediainjector.gt667`
      text-align: center;
      li {
        display: inline-block;
        padding: 0 0.6em;
        a {
          display: inline-block;
          padding: 0.3em 1em;
          border: 1px solid #fff;
          border-radius: 6px;
        }
      }
    `}
  }
`;

const Title = styled.h2`
  font-size: 18px;
  margin: 24px 0;
`;

const year = new Date().getFullYear();

class Footer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      bgcolor,
      color,
      guide = []
    } = this.props;

    return (
      <FooterWrap
        bgcolor={bgcolor}
        color={color}
      >
        {guide.length > 0 && (
          <LinkList paddingBottom="0">
            <ul>
              {guide.map(({ id, titolo, stud }) => (
                <li key={id}>
                  <a href={`/${stud}`}>{titolo}</a>
                </li>
              ))}
            </ul>
          </LinkList>
        )}
        <LinkList>
          <Title>La nostra offerta didattica:</Title>
          <ul>
            <li><a href="https://alatin.it/" title="vai alla home di Alatin Academy - latino per il biennio">Alatin - latino biennio</a></li>
            <li><a href="https://lyceum-alatin.it/" title="vai alla home di Alatin Lyceum - latino per il triennio">Lyceum - latino triennio</a></li>
            <li><a href="https://praxisacademy.it/" title="vai alla home di Praxis - greco">Praxis - greco</a></li>
            <li><a href="https://itaca.academy/" title="vai alla home di Itaca Academy - grammatica italiana">Itaca - grammatica italiana</a></li>
            <li><a href="https://alextutor.it/" title="vai alla home di Alex - tutor per la comprensione e l'analisi del testo">Alex - analisi del testo</a></li>
            <li><a href="https://mathx.it/" title="vai alla home di MathX - matematica">MathX - matematica per la scuola superiore</a></li>
          </ul>
        </LinkList>
        <section>
          <p>© {year}&nbsp;
            <span key="span_1">
              <a href="https://maieuticallabs.it" title="Maieutical Labs sito ufficiale" rel="noopener noreferrer" target="_blank">
                Maieutical Labs
              </a>
              <span className="mediumUp"> srl &bull;&nbsp;</span>
            </span>
            <span key="span_3">
              <span className="smallOnly"><br /><br /></span>
              P. IVA 10623350013 &bull; Tutti i diritti riservati
            </span>
          </p>
        </section>
      </FooterWrap>
    );
  }
}

Footer.propTypes = {
  altCopy: PropTypes.string,
  address: PropTypes.string,
  bgcolor: PropTypes.string,
  color: PropTypes.string,
};

export default Footer;
